<template>  
  <div>
      <q-list-header>Application Side Workspace</q-list-header>
    <q-item @click.native="openURL('https://twitter.com/quasarframework')">
          <q-item-side icon="rss feed" />
          <q-item-main label="Twitter" sublabel="@quasarframework"></q-item-main>
        </q-item>
  </div>
</template>

<script>
import { openURL } from 'quasar'

export default {
  name: 'SideSpace',
  data () {
    return {
      testX: false
    }
  },
  methods: {
    openURL
  }
}
</script>

<style>
</style>
